import { Dispatch } from 'redux';
import { ReduxComponentInterface } from 'edocatbase/Global';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Modal } from '../../../../ModalTest';
import Button from '../../../../Button';
import { toggleModal } from '../../../../ModalTest/actions';

interface DeleteTableItemModalProps extends ReduxComponentInterface {
  items: any;
  name: string;
  formInstanceId: string;
  actions: any;
}

class DeleteTableItemModal extends React.PureComponent<DeleteTableItemModalProps> {
  onModalClose = (event: MouseEvent) => {
    const { actions, name, formInstanceId } = this.props;
    event && event.preventDefault();
    actions.toggleModal(false, `${name}deleteTableItemModal`, null, formInstanceId);
  };

  onSubmit = async (event: MouseEvent) => {
    event.preventDefault();
    const {
      actions,
      name,
      formInstanceId,
      items: { callback },
    } = this.props;

    await callback();
    actions.toggleModal(false, `${name}deleteTableItemModal`, null, formInstanceId);
  };

  render() {
    const {name} = this.props;
    return (
      <Modal
        name={`${name}deleteTableItemModal`}
        title={window.Alfresco.messages.global[`edocat.document-details.table-delete-item-label`]}
      >
        <div className="modal-body">{window.Alfresco.messages.global['edocat.document-details.table-delete-item']}</div>
        <div className="modal-actions">
          <Button onClick={this.onSubmit} label={window.Alfresco.messages.global['button.ok']} primary />
          <Button onClick={this.onModalClose} label={window.Alfresco.messages.global['button.close']} />
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = (state: any, props: any) => ({
  items: state.modal?.[`${props.name}deleteTableItemModal`]?.items,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: bindActionCreators(
    { toggleModal},
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteTableItemModal);